exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.action-link[data-v-608de639] {\n    cursor: pointer;\n}\n", ""]);

// exports
